import React, { FunctionComponent, ButtonHTMLAttributes } from "react";
import styled from "styled-components";

import { Device } from "@/utils/device";
import { CL } from "@/components/Typography";
import colours from "@/utils/colours";

interface RxStickyButtonStripProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonText: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  backgroundColour?: string;
  textColour?: string;
}

const RxStickyButtonStrip: FunctionComponent<RxStickyButtonStripProps> = (
  props
) => {
  return (
    <S.StripContainer data-cy="button-strip">
      <S.Button
        backgroundColour={props.backgroundColour || colours.teal}
        disabled={props.disabled}
        id={props.name}
        onClick={props.onClick}
        type={props.type || "button"}
      >
        <CL colour={props.textColour || colours.shell} weight="700">
          {props.buttonText}
        </CL>
      </S.Button>
    </S.StripContainer>
  );
};

type StyleProps = {
  backgroundColour?: string;
};

const S = () => {};

S.StripContainer = styled.div`
  position: fixed;
  bottom: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 99;

  @media (min-width: ${Device.mobile}) {
    bottom: 0;
    left: 0;
  }
`;

S.Button = styled.button<StyleProps>`
  width: 100%;
  max-width: 28rem;
  border: none;
  border-radius: 4rem;
  background: ${(p) => p.backgroundColour};
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  transition: all 0.2s ease-out;
  transition: transform 0.1s ease-out;

  &:active {
    transform: scale(0.95);
  }

  @media (min-width: ${Device.mobile}) {
    border-radius: 0;
    width: 100%;
    max-width: ${Device.max};

    &:active {
      transform: scale(1);
    }
  }

  ${(p) =>
    p.disabled
      ? `
    filter: brightness(0.8);
    pointer-events: none;
  `
      : `
    &:hover {
      cursor: pointer;
      filter: brightness(1.1);
    }
  `}
`;

export default RxStickyButtonStrip;
